export const LCP_SHELL_ID = 'yovo-lcp-shell';
export const LCP_CARD_ID = 'yovo-lcp-card';
export const LCP_SHELL_ROOT_CLASS = 'yovo-home-shell';
/** Matches the shell CSS: hidden from 900px up. */
export const LCP_SHELL_DESKTOP_MIN_PX = 900;

/** The static shell is only for a full load of the homepage. */
export function isLcpShellPath(pathname) {
  const path = String(pathname || '/').replace(/\/+$/, '') || '/';
  return path === '/';
}

/** True when the viewport is the desktop width that hides the shell. */
export function shouldRemoveLcpShellForWidth(width) {
  return Number(width) >= LCP_SHELL_DESKTOP_MIN_PX;
}

/**
 * Drop the static header, the search-card skeleton, and the pull-up class.
 * All three go in one turn so the real header and card stay where they are.
 */
export function removeLcpShell(doc = document) {
  doc.getElementById(LCP_CARD_ID)?.remove();
  doc.getElementById(LCP_SHELL_ID)?.remove();
  doc.documentElement.classList.remove(LCP_SHELL_ROOT_CLASS);
}
